// extracted by mini-css-extract-plugin
export default {"imageContainer":"YZ-z","summaryPar":"ZZ-z","ratingCategories":"_Z-z","reviewerInfo":"a0-z","reviewTypes":"b0-z","expanded":"c0-z"};